<template>
    <div class="finance-page transaction-page main-wrapper">
        <div class="transaction-page__inner">
            <header class="tx-header">
                <div>
                    <h1 class="tx-header__title">{{ $t('transaction.transactions') }}</h1>
                    <p class="tx-header__subtitle">
                        {{ $store.state.language === 'en'
                            ? 'Deposits, withdrawals, and balance changes.'
                            : 'ငွေသွင်း၊ ငွေထုတ် နှင့် လက်ကျန်ပြောင်းလဲမှုများ။' }}
                    </p>
                </div>
            </header>

            <div class="tx-toolbar">
                <div class="tx-filters" role="tablist" aria-label="Transaction type">
                    <button
                        type="button"
                        role="tab"
                        class="tx-pill"
                        :class="{ 'tx-pill--active': transactionType === 'all' }"
                        @click="fetchHistory('all')"
                    >
                        {{ $t('transaction.all') }}
                    </button>
                    <button
                        type="button"
                        role="tab"
                        class="tx-pill tx-pill--in"
                        :class="{ 'tx-pill--active': transactionType === 'in' }"
                        @click="fetchHistory('in')"
                    >
                        {{ $t('transaction.deposit') }}
                    </button>
                    <button
                        type="button"
                        role="tab"
                        class="tx-pill tx-pill--out"
                        :class="{ 'tx-pill--active': transactionType === 'out' }"
                        @click="fetchHistory('out')"
                    >
                        {{ $t('transaction.withdraw') }}
                    </button>
                </div>
                <div class="tx-search-row">
                    <div class="tx-date transaction">
                        <v-select
                            v-model="params.date"
                            :reduce="(draw) => draw.data"
                            label="label"
                            :options="dateOptions"
                            :placeholder="$store.state.language === 'en' ? 'Date' : 'ရက်စွဲ'"
                        />
                    </div>
                    <button type="button" class="tx-search-btn" @click="fetchHistory">
                        {{ $t('transaction.search') }}
                    </button>
                </div>
            </div>

            <div class="tx-table-wrap betslip-table">
                <div v-if="isLoading" class="tx-loading">
                    <Loading color="#f06126" size="28" class="tx-loading__spin"/>
                    <span class="tx-loading__text">{{ $t('please_wait') }}</span>
                </div>
                <DataTable
                    v-if="!isLoading"
                    variant="finance"
                    :tableData="tableData"
                    @getSlipData="fetchSlipData"
                />
                <div v-if="!isLoading" class="tx-pagination-wrap">
                    <van-pagination
                        v-model="currentPage"
                        :total-items="rows"
                        :items-per-page="10"
                        :show-page-size="3"
                        class="tx-pagination"
                        force-ellipses
                    >
                        <template #prev-text>
                            <van-icon name="arrow-left" />
                        </template>
                        <template #next-text>
                            <van-icon name="arrow" />
                        </template>
                        <template #page="{ text }">{{ text }}</template>
                    </van-pagination>
                </div>
            </div>
        </div>

        <div class="col-4">
            <div
                class="modal fade"
                id="voucher-history"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
            >
                <div class="modal-dialog modal- modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="text-center modal-cross" @click="closeModal">X</div>
                        <div class="modal-body p-0">
                            <FBVoucher
                                :type="type"
                                :datas="datas"
                                :slipId="slipId"
                                :currentTime="bet_date"
                                :isHistory="true"
                                :is_result="is_result"
                                :bingo_amount="bingo_amount"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime } from 'luxon';
import { Loading } from 'vant';
import DataTable from './components/DataTable.vue';
import FBVoucher from './components/FBVoucher.vue';
import { mapActions } from 'vuex';

export default {
  components: { DataTable, FBVoucher, Loading },
  data() {
    return {
      tableData: {
        headings: [this.$t('voucher.total_amount'), this.$t('transaction.balance'), this.$t('transaction.type'), this.$t('transaction.status'), this.$t('transaction.action_by'), this.$t('voucher.bet_date')],
        datas: [],
      },
      rows: 1,
      currentPage: 1,
      depositActive: false,
      withdrawActive: false,
      transactionType: 'all',
      params: {
        draw: '',
        date: '',
      },
      dateOptions: [],
      type: 'maung',
      datas: [],
      slipId: null,
      bet_date: null,
      bingo_amount: null,
      is_result: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format('l');
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    closeModal() {
      $('#voucher-history').modal('hide');
    },
    fetchSlipData(data) {
      this.type = data.type;
      this.datas = data.team_vouchers;
      this.bingo_amount = data.bingo_amount;
      this.slipId = data.voucher_id;
      this.is_result = data.isBet;
      this.bet_date = this.betTime(data.created_at);
      $('#voucher-history').modal('show');
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    async fetchHistory(type = 'all') {
      try {
        this.transactionType = type;
        this.isLoading = true;
        this.tableData.contents = [
          'amount',
          'current_amount',
          'type',
          'status',
          'by_user_name',
          'created_at',
        ];
        const res = await axios.post('/transactions/get_by_solo', {
          page: this.currentPage,
          limit: 10,
          user_id: this.$store.state.authUser.id,
          drawDate: this.params.date,
          type,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
        this.tableData.datas = res.data.data;
        for (let index = 0; index < this.tableData.datas.length; index += 1) {
          this.tableData.datas[index].created_at = this.betTime(this.tableData.datas[index].created_at);
          this.tableData.datas[index].amount = Number(this.tableData.datas[index].amount).toLocaleString();
          this.tableData.datas[index].current_amount = Number(this.tableData.datas[index].current_amount).toLocaleString();
        }
        this.isLoading = false;
        this.rows = res.data.total;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  watch: {
    currentPage() {
      this.fetchHistory(this.transactionType);
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    await this.fetchHistory();
    this.setOneMonth();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    this.params.date = moment(new Date()).format('l');
  },
};
</script>
<style scoped>
.transaction-page {
  --tx-accent: rgb(240, 97, 38);
  --tx-accent-soft: rgba(240, 97, 38, 0.25);
  --tx-surface: #141414;
  --tx-muted: #9a9a9a;
  min-height: 90vh;
  overflow-y: auto;
  padding: 1rem 0.75rem 5rem;
  background:
    radial-gradient(ellipse 70% 45% at 50% -10%, rgba(240, 97, 38, 0.1), transparent),
    #101010;
  -webkit-overflow-scrolling: touch;
}

.transaction-page__inner {
  max-width: 960px;
  margin: 0 auto;
}

.tx-header__title {
  font-size: 1.35rem;
  font-weight: 600;
  color: #f0f0f0;
  margin: 0 0 0.35rem;
  letter-spacing: -0.02em;
}

.tx-header__subtitle {
  margin: 0;
  font-size: 0.82rem;
  color: var(--tx-muted);
  line-height: 1.45;
}

.tx-toolbar {
  margin-top: 1.25rem;
  padding: 1rem;
  border-radius: 14px;
  background: var(--tx-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
}

.tx-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.tx-pill {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.35);
  color: #ccc;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.45rem 0.95rem;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.tx-pill:hover {
  border-color: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.tx-pill--active {
  background: linear-gradient(180deg, rgba(255, 140, 66, 0.35) 0%, rgba(240, 97, 38, 0.2) 100%);
  border-color: var(--tx-accent-soft);
  color: #fff;
}

.tx-pill--in.tx-pill--active {
  border-color: rgba(46, 204, 113, 0.45);
  background: linear-gradient(180deg, rgba(46, 204, 113, 0.2) 0%, rgba(20, 40, 30, 0.5) 100%);
}

.tx-pill--out.tx-pill--active {
  border-color: rgba(231, 76, 60, 0.45);
  background: linear-gradient(180deg, rgba(231, 76, 60, 0.18) 0%, rgba(40, 20, 20, 0.5) 100%);
}

.tx-search-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.65rem;
}

.tx-date {
  flex: 1 1 200px;
  min-width: 0;
}

.tx-search-btn {
  flex: 0 0 auto;
  align-self: flex-end;
  min-height: 44px;
  padding: 0 1.25rem;
  border-radius: 12px;
  border: 1px solid var(--tx-accent-soft);
  background: linear-gradient(180deg, #ff8c42 0%, var(--tx-accent) 55%, #c94a18 100%);
  color: #0d0d0d;
  font-weight: 700;
  font-size: 0.88rem;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(240, 97, 38, 0.25);
  transition: transform 0.1s ease;
}

.tx-search-btn:active {
  transform: scale(0.98);
}

.tx-table-wrap {
  margin-top: 1rem;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: #0d0d0d;
}

.betslip-table {
  background: transparent !important;
}

.tx-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 3rem 1rem;
}

.tx-loading__text {
  font-size: 0.9rem;
  color: var(--tx-muted);
}

.tx-pagination-wrap {
  padding: 1rem;
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.25);
}

.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}
</style>
<style>
/* Vant pagination on dark background */
.transaction-page .tx-pagination .van-pagination__item {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #ccc !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.transaction-page .tx-pagination .van-pagination__item--active {
  background: rgba(240, 97, 38, 0.35) !important;
  color: #fff !important;
  border-color: rgba(240, 97, 38, 0.5) !important;
}

.transaction-page .transaction .vs__dropdown-toggle {
  min-height: 44px !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  background: #0a0a0a !important;
}

.transaction-page .transaction .vs__selected,
.transaction-page .transaction .vs__search {
  color: #fff !important;
}

.transaction-page .transaction .vs__dropdown-menu {
  background: #1a1a1a !important;
  border: 1px solid rgba(240, 97, 38, 0.25) !important;
  border-radius: 12px !important;
}
</style>
